import type { Adventure } from '../../types'

// Age 3: Counting Apples - First Adventure
export const countingApplesAdventure: Adventure = {
  id: 'counting-apples',
  title: 'Count the Apples',
  theme: 'counting',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 5,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hi friend! I'm Tilly! Let's count some apples together! Are you ready?",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at these yummy apples! I wonder how many there are? Let's find out!",
      duration: 5,
      background: 'orchard'
    },
    choice1: [
      {
        id: 'count-together',
        label: "Let's count!",
        tillyLine: "Yay! Counting is fun! Let's look at the apples!",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'count-and-tap',
      question: 'Count the apples!',
      tillyPrompt: 'How many apples do you see?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      // For count-and-tap, we use targetNumber instead
      targetNumber: 3,
      objectEmoji: '🍎'
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great counting! Now let's count some stars in the sky!",
      duration: 4,
      background: 'night-sky'
    },
    choice2: [
      {
        id: 'count-stars',
        label: "Count stars!",
        tillyLine: "Stars are so pretty! Let's count them!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'count-and-tap',
      question: 'Count the stars!',
      tillyPrompt: 'How many stars are twinkling?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      targetNumber: 5,
      objectEmoji: '⭐'
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Wow! You're such a good counter! Now for the big challenge - count the butterflies!",
        duration: 5,
        background: 'meadow'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'count-and-tap',
          question: 'Count the butterflies!',
          tillyPrompt: 'How many butterflies are flying?',
          options: [
            { id: '3', label: '3', isCorrect: false },
            { id: '4', label: '4', isCorrect: true },
            { id: '5', label: '5', isCorrect: false }
          ],
          targetNumber: 4,
          objectEmoji: '🦋'
        } as any
      ]
    },
    reward: {
      tillyLine: "Amazing work! You're a counting champion! Here's your Apple Counter badge!",
      badgeName: 'Apple Counter',
      badgeIcon: '🍎',
      nextPreview: 'Next time, we\'ll learn about numbers!'
    }
  }
}

// Tilly's reactions for correct answers
export const tillyCorrectReactions = [
  "Wow! That's right! You're so smart!",
  "Amazing! You got it!",
  "Yes! Perfect counting!",
  "Super job! You're a math star!",
  "Excellent! You really know your numbers!",
  "That's it! Great work!",
  "You did it! I'm so proud of you!",
  "Perfect! You're getting so good at this!",
  "Woo hoo! Correct!",
  "Brilliant! You counted perfectly!"
]

// Tilly's reactions for wrong answers (encouraging)
export const tillyWrongReactions = [
  "Oops! That's not quite right. Let's try again!",
  "Not quite, but you're learning! Try once more!",
  "Good try! Counting can be tricky. Let's keep practicing!",
  "Almost! Let's look at it again together!",
  "That's okay! Making mistakes is how we learn!",
  "Not that one, but I know you'll get it next time!",
  "Keep trying! You're doing great!",
  "Let's count together: one, two, three...",
  "That's not it, but I love how hard you're trying!",
  "No worries! Let's try a different answer!"
]

// Tilly's celebration reactions
export const tillyCelebrationReactions = [
  "🎉 YOU DID IT! 🎉",
  "You're a MATH SUPERSTAR! 🌟",
  "Amazing counting! I'm so proud of you! 🎊",
  "You finished the whole adventure! WOW! 🏆",
  "Look at you go! You're a counting champion! 🥇"
]

// Helper to get random reaction
export function getRandomReaction(reactions: string[]): string {
  return reactions[Math.floor(Math.random() * reactions.length)]
}
